import React from 'react';
import { Container, Row, Col, Image } from 'react-bootstrap';
import SeoMeta from '../components/SeoMeta';
import '../styles/AboutPage.css';
import '../styles/PageHero.css';

function AboutPage() {
    return (
        <div className="about-page">
            <SeoMeta
                title="About Ziyad Attorneys | Addis Ababa, Ethiopia"
                description="Learn about Ziyad Attorneys, founded by Ziyad Redwan in 2014 to provide professional legal representation in Ethiopia."
            />
            
            {/* Hero Section */}
            <div
                className="about-hero page-photo-hero" 
                style={{ 
                    backgroundImage: 'url(o5p.png)', 
                    backgroundSize: 'cover', 
                    backgroundPosition: 'center',
                    position: 'relative',
                    display: 'flex',
                    justifyContent: 'center'
                }}
            >
                <div className="about-hero-overlay">
                    <h1 className="page-header-title page-hero-title">
                        About <span className="highlight">Ziyad Attorneys</span>
                    </h1>
                    <p className="page-header-subtitle page-hero-subtitle">
                        Excellence in Legal Representation Since 2014
                    </p>

                </div>
            </div>

            {/* About Us Section */}
            <Container className="my-5 container-custom about-intro-section">
                <Row>
                    <Col md={6}>
                        <Image 
                            src="zk1pc.png"
                            fluid 
                            rounded 
                            className="shadow-lg about-lawyer-image"
                            style={{ width: "100%", maxWidth: "600px", height: "400px", objectFit: "cover", marginTop: "10px" }}
                        />
                    </Col>
                    <Col md={6}>
                        <h2 className="mb-4" style={{ fontSize: "2.2rem", fontWeight: "bold", color: "#303a61ff" }}>About Us</h2>
                        <p>
                            Ziyad Attorneys is dedicated to upholding justice and the rule of law. 
                            Founded by Ziyad Redwan in 2014, our firm has steadily expanded across multiple 
                            legal practice areas, bringing together highly skilled professionals. 
                            For over a decade, we have served a diverse range of clients, guided by our core 
                            principle: <strong>Truth Wins</strong>. Our commitment is to ensure justice is 
                            accessible to all, without bias or discrimination.
                        </p>
                        <p>
                            Ziyad Redwan, with 17+ years of experience in Ethiopia's legal and judicial sectors, 
                            holds an LLB and LLM from Addis Ababa University and is currently pursuing his PhD in law. 
                            His extensive expertise, combined with a diverse team of legal practitioners, 
                            allows us to provide comprehensive legal services in various fields.
                        </p>

                    </Col>
                </Row>
            </Container>

            {/* Our Mission Section */}
            <Container className="my-5 mission-section">
                <Row className="align-items-center">
                    {/* Text Left */}
                    <Col md={6}>
                        <h2 className="mb-4" style={{ fontSize: "2.2rem", fontWeight: "bold", color: "#303a61ff" }}>
                            Our Mission
                        </h2>
                        <p style={{ fontSize: "1.1rem", lineHeight: "1.8", color: "#333" }}>
                            Our mission is to provide <strong>accessible, professional, and trustworthy legal services</strong> 
                            to all individuals and businesses. We believe in the power of law to protect rights, uphold 
                            justice, and foster fairness in society. 
                        </p>
                        <p style={{ fontSize: "1.1rem", lineHeight: "1.8", color: "#333" }}>
                            By combining decades of expertise with a <strong>client-first approach</strong>, we aim to be 
                            not only your advocates but also your trusted partners in navigating the complexities of 
                            the legal system.
                        </p>
                    </Col>

                    {/* Image Right */}
                    <Col md={6} className="text-center">
                        <Image 
                            src="o1cp.png"
                            fluid 
                            rounded 
                            className="shadow-lg about-office-image"
                            style={{ maxWidth: "70%", height: "auto", }}
                        />
                    </Col>
                </Row>
            </Container>

            {/* Our Values Section */}
            <Container className="my-5 values-section">
                <Row className="align-items-start">
                    <Col md={6} className="text-center">
                        <Image 
                            src="bigrum.jpg" 
                            fluid 
                            rounded 
                            className="shadow-lg" 
                            style={{ width: "100%", maxWidth: "600px", height: "400px", objectFit: "cover", marginTop: "10px" }}
                        />
                    </Col>
                    <Col md={6}>
                        <h2 className="mb-4" style={{ fontSize: "2.2rem", fontWeight: "bold", color: "#303a61ff" }}>
                            Our Values
                        </h2>
                        <p style={{ fontSize: "1.1rem", lineHeight: "1.8", color: "#333" }}>
                            Our work is guided by four core values that define who we are and how we serve:
                        </p>
                        <ul style={{ fontSize: "1.05rem", lineHeight: "1.8", color: "#333" }}>
                            <li><strong>Integrity:</strong> Acting with honesty, fairness, and transparency in all matters.</li>
                            <li><strong>Excellence:</strong> Striving for the highest professional standards in every case.</li>
                            <li><strong>Client-Centered:</strong> Placing your needs and goals at the heart of our service.</li>
                            <li><strong>Justice for All:</strong> Ensuring fairness and equal treatment for every client.</li>
                        </ul>
                    </Col>
                </Row>
            </Container>

        </div>
    );
}

export default AboutPage;
